import {QueryEntity} from '@datorama/akita';
import {Observable} from 'rxjs';
import {OperationItemsState, OperationItemsStore,} from './operation-items.store';

export class OperationItemsQuery extends QueryEntity<OperationItemsState> {
  page$: Observable<number>;
  pageSize$: Observable<number>;
  lastPage$: Observable<boolean>;

  constructor(protected store: OperationItemsStore) {
    super(store);
    this.lastPage$ = this.select((state) => state.lastPage);
    this.page$ = this.select((state) => state.page);
    this.pageSize$ = this.select((state) => state.pageSize);
  }
}
